// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ht-1";
export var messageSideRight = "_ht-2";
export var orderLookupBubbleContainer = "_ht-0";
export var submitButton = "_ht-3";